<ui-tab-group class="hidden sm:block">
  <a
    routerLink="./general"
    routerLinkActive
    #general="routerLinkActive"
    [attr.aria-current]="general.isActive"
    data-track="cockpit-settings-tab-general"
    *hasPermission="['ORGANIZATION_MASTERDATA_WRITE']"
  >
    <ui-tab [active]="general.isActive">
      <h2 class="flex">
        <ng-icon name="heroInformationCircle" size="20" class="!block mr-2" />
        {{ 'cockpit.settings.nav.general' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./address"
    routerLinkActive
    #address="routerLinkActive"
    [attr.aria-current]="address.isActive"
    data-track="cockpit-settings-tab-address"
    *hasPermission="['ORGANIZATION_MASTERDATA_WRITE']"
  >
    <ui-tab [active]="address.isActive">
      <h2 class="flex">
        <ng-icon name="heroCreditCard" size="20" class="!block mr-2" />
        {{ 'cockpit.settings.nav.address' | transloco }}
      </h2>
    </ui-tab>
  </a>
  <a
    routerLink="./members"
    routerLinkActive
    #members="routerLinkActive"
    [attr.aria-current]="members.isActive"
    data-track="cockpit-settings-tab-members"
    *hasPermission="['ORGANIZATION_INVITE_USER']"
  >
    <ui-tab [active]="members.isActive">
      <h2 class="flex">
        <ng-icon name="heroUserGroup" size="20" class="!block mr-2" />
        {{ 'cockpit.settings.nav.members' | transloco }}
      </h2>
    </ui-tab>
  </a>
</ui-tab-group>
<div class="sm:hidden">
  <ui-select (selectChange)="onSelectChange($event)">
    <option
      routerLink="./general"
      value="./general"
      routerLinkActive
      #generalMobile="routerLinkActive"
      [selected]="generalMobile.isActive"
      *hasPermission="['ORGANIZATION_MASTERDATA_WRITE']"
    >
      {{ 'cockpit.settings.nav.general' | transloco }}
    </option>
    <option
      routerLink="./address"
      value="./address"
      routerLinkActive
      #addressMobile="routerLinkActive"
      [selected]="addressMobile.isActive"
      *hasPermission="['ORGANIZATION_MASTERDATA_WRITE']"
    >
      {{ 'cockpit.settings.nav.address' | transloco }}
    </option>
    <option
      routerLink="./members"
      value="./members"
      routerLinkActive
      #membersMobile="routerLinkActive"
      [selected]="membersMobile.isActive"
      *hasPermission="['ORGANIZATION_INVITE_USER']"
    >
      {{ 'cockpit.settings.nav.members' | transloco }}
    </option>
  </ui-select>
</div>
